import React, { useState } from "react";

interface CustomTextAreaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const CustomTextArea = React.forwardRef<
    HTMLTextAreaElement,
    CustomTextAreaProps
>(({ value, className, ...rest }, ref) => {
    return (
        <textarea
            ref={ref} // Pass the forwarded ref here
            value={value}
            className={`input-text-area ${className ?? ""}`}
            {...rest}
        />
    );
});

export default CustomTextArea;
